import React, { Component } from 'react';
import axios from 'axios';
import './styles/App.css';
// import Cookies from 'universal-cookie';
import isEmail from 'validator/lib/isEmail';

class Subscription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      valid: false,
    }

    this.submit = this.submit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleEmailChange(event) {
    var email = event.target.value;
    this.setState({ email: email, valid: isEmail(email) });
  }

  submit(event) {
    event.preventDefault();

    axios.post(process.env.REACT_APP_API + '/api/suggestion/', { description: this.state.description, link: this.state.link })
    .then((response) => {
      this.setState({ link: "", description: "", valid: false });
      alert(response.data);
    })
    .catch((error) => {
      alert("An error occurred. We apologize for the inconvenience!");
    });
  }

  render() {
    return (
      <div className="subscription-div box-shadow w-100">
      <h2>Subscribe</h2>
      <p>We send out monthly emails showcasing the best or most notable models released each month. Sign up to receive updates!</p>
      <hr/>

        <div id="mc_embed_signup">
        <form action="https://modelzoo.us18.list-manage.com/subscribe/post?u=c5478ec8892374b3bf30ad38b&amp;id=b4f2343722" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
        <div id="mc_embed_signup_scroll">
          
        <div className="mc-field-group input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1"><i class="fas fa-envelope"></i></span>
          </div>
          <input type="text" value={this.state.email} onChange={this.handleEmailChange} name="EMAIL" className={"form-control email " + (this.state.email.length === 0 ? "" : (this.state.valid ? "is-valid" : "is-invalid"))} id="mce-EMAIL" placeholder="youremail@domain.com" />
          { this.state.email.length === 0 ?
            "" :
            <div className={ this.state.valid ? "valid-feedback" : "invalid-feedback" }>
            { this.state.valid ? "" : "Please enter a valid email!" }
            </div>
          }
        </div>
        <br/>

        <div id="mce-responses" className="clear">
          <div className="response" id="mce-error-response" style={{display: 'none'}}></div>
          <div className="response" id="mce-success-response" style={{display: 'none'}}></div>
        </div>
          <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_c5478ec8892374b3bf30ad38b_b4f2343722" tabIndex="-1" value="" /></div>
          <div className="clear"><input type="submit" disabled={!this.state.valid} value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn btn-primary button" /></div>
        </div>
        </form>
        </div>
      </div>
    )
  }
}

export default Subscription;


// WEBPACK FOOTER //
// ./src/Subscription.jsx